const mEditionBillingMyShopping = {
  mEditionBillingMyShopping: {
    buttonSecondary: {
      download: {
        text: 'Exportar',
        subText: 'Formato'
      },
      filterText: 'Filtros Avanzados'
    },

    free: 'Gratis',

    table: {
      thDate: 'Fecha',
      thDetail: 'Detalle',
      thDiscount: 'Desc.',
      thInvoice: 'Ver',
      thMethod: 'Medio',
      thRecord: 'Ver',
      thToPay: 'A Pagar',
      thTotal: 'Total'
    },

    tooltips: {
      actions: 'Acciones',
      shopping: 'Ver Compra',
      restart: 'Actualizar'
    }
  }
}

export default mEditionBillingMyShopping
